import { Maybe as HygraphMaybe, Side as HygraphSide } from '@/lib/types';

import { Side } from '@/enums/side';

export default function sideTransformer(
  props: HygraphMaybe<HygraphSide> | undefined
) {
  switch (props) {
    case HygraphSide.Left:
      return Side.LEFT;
    case HygraphSide.Right:
      return Side.RIGHT;
    default:
      return undefined;
  }
}
